export default "__VITE_ASSET__QBr6fl2c__"